import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { CALLDASHBOARD, CHANGEPASSWORD, DASHBOARD, FULFILLED, REJECTED, SIGNIN } from 'src/common/constants'
import logo from '../../assets/images/aiva-logo-black.svg';
import { useEffect, useState } from 'react'
import * as Yup from "yup";
import { ThunkDispatch } from '@reduxjs/toolkit'
import { useTranslation } from 'react-i18next'
import { IUserLogin } from 'src/types/user.type';
import { admin, signIn, signInRememberEmailHandler, signInRememberMeHandler, user } from 'src/store/slices/authSlice'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-toastify';
import { RootState } from 'src/store/store'
import { setActiveSidemenu } from 'src/store/slices/settingsSlice'

const Signin = () => {
    //single hooks starts here
    const dispatch: ThunkDispatch<object, object, any> = useDispatch();
    const navigate = useNavigate()
    const { t } = useTranslation('common');
    //single hooks ends here

    //useSelector starts here
    const { signInRememberMe, signInRememberEmail } = useSelector((state: RootState) => state.auth)
    //useSelector ends here

    //useStates starts here
    const [passwordType, setPasswordType] = useState("password");
    //useStates ends here

    //functions starts here
    const handleSignin = async (formValue: IUserLogin) => {
        const email = formValue?.email;
        const password = formValue?.password
        const data = {
            email,
            password
        }
        await dispatch(signIn(data)).then((res: any) => {
            if (res?.type === `${(SIGNIN)}/${FULFILLED}`) {
                if (res.payload.roleUser === false) {
                    dispatch(admin(res?.payload))
                    toast.success((t('auth.signin')), {
                        position: "top-right",
                        autoClose: 3000,
                    });
                    navigate(CALLDASHBOARD);
                    dispatch(setActiveSidemenu('Dashboard'))
                }
                else {
                    if (res?.payload?.user.forceChngPwd === true) {
                        navigate((`/${CHANGEPASSWORD}`))
                        dispatch(user(res?.payload))
                        const today: any = new Date();
                        const dbDateObj: any = new Date(res?.payload?.user?.lastPwdChngAt);
                        const timeDiff = Math.abs(today - dbDateObj);
                        const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
                        if (res?.payload?.user?.lastPwdChngAt == null) {
                            toast.warning(t('auth.changePassword'), {
                                position: "top-right",
                                autoClose: 3000,
                            });
                        }
                        else if (dayDiff >= 90) {
                            toast.warning(t("auth.passwordValidation"), {
                                position: "top-right",
                                autoClose: 3000,
                            });
                        }
                    }
                    else {
                        dispatch(user(res?.payload))
                        toast.success(String(t('auth.loginSuccessFul')), {
                            position: "top-right",
                            autoClose: 2500,
                        })
                        navigate((`${res.payload.user.assignedTenants[0].code}/${DASHBOARD}`));
                    }
                }
            } else if (res?.type === `${(SIGNIN)}/${REJECTED}`) {
                toast.error(res?.payload, {
                    position: "top-right",
                    autoClose: 2500,
                });
            } else {
                toast.error(String(t('toastMessage.loginFailed')), {
                    position: "top-right",
                    autoClose: 2500,
                });
            }

        })
    }

    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }
    //functions ends here

    //yup validation starts here
    const initialValues: any = {
        email: signInRememberEmail,
        password: ""
    };

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .required(t('validation.requiredField'))
            .transform((value, originalValue) => {
                if (typeof originalValue === 'string') {
                    return originalValue.trim();
                }
                return value;
            })
            .email(t('validation.notValidEmail')),
        password: Yup.string()
            .required(t('validation.requiredField')).transform((value, originalValue) => {
                if (typeof originalValue === 'string') {
                    return originalValue.trim();
                }
                return value;
            }),
    });
    //yup validation ends here

    //useEffect starts here
    useEffect(() => {
        if (signInRememberMe === false) {
            dispatch(signInRememberEmailHandler(''));
        }
    }, [])
    //useEffect ends here
    return (
        <div id="main-wrapper" className="login-register">
            <div className="container-fluid">
                <div className="row gx-0 justify-content-center">
                    <div className="col-md-7 col-lg-10 col-xl-8 shadow-lg">
                        <div className="row gx-0">
                            <div className="col-lg-6">
                                <div className='hero-wrap d-flex align-items-center justify-content-center'>
                                    <div className="logo-img">
                                        <img src={logo} alt="logo" className='img-fluid' width='300' />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className='login-from'>
                                    <h3 className="fw-600 mb-4">Sign In</h3>
                                    <Formik
                                        initialValues={initialValues}
                                        validationSchema={validationSchema}
                                        onSubmit={handleSignin}
                                    >
                                        <Form className="vstack gap-4">
                                            {/* Email Input */}
                                            <div>
                                                <Field
                                                    name="email"
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="Enter Your Email"
                                                />
                                                <ErrorMessage
                                                    name="email"
                                                    component="div"
                                                    className="text-danger txt-error error-msg"
                                                />
                                            </div>

                                            {/* Password Input */}
                                            <div className="password-toggle">
                                                <Field
                                                    name="password"
                                                    type={passwordType}
                                                    className="form-control password pe-5"
                                                    placeholder="Enter Password"
                                                />
                                                <button
                                                    type="button"
                                                    onClick={togglePassword}
                                                    className="password-toggle-btn btn btn-link p-0 text-black"
                                                >
                                                    <FontAwesomeIcon
                                                        icon={passwordType === 'password' ? faEye : faEyeSlash}
                                                    />
                                                </button>
                                                <ErrorMessage
                                                    name="password"
                                                    component="div"
                                                    className="text-danger txt-error error-msg"
                                                />
                                            </div>

                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className="hstack ">
                                                    <div className="form-check">
                                                        <Field
                                                            className="form-check-input"
                                                            name="isRememberMe"
                                                            type="checkbox"
                                                            id="user-remember"
                                                            checked={signInRememberMe}
                                                            onChange={(e: any) => dispatch(signInRememberMeHandler(e.target.checked))}
                                                        />
                                                        <label className="form-check-label" htmlFor="user-remember">
                                                            Remember Me
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="text-end">
                                                    <Link to="/forgot-password" className="text-decoration-none cs-color">
                                                        Forgot Password?
                                                    </Link>
                                                </div>

                                            </div>

                                            {/* Submit Button */}
                                            <div className="d-grid mb-3">
                                                <button className="btn btn-primary" type="submit">
                                                    Sign In
                                                </button>
                                            </div>
                                        </Form>
                                    </Formik>
                                    <p className="text-center cs-text fw-5">
                                        Don't have an account? <a className="link-primary" href="#">Sign Up</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Signin;